import React from 'react';
import { createPortal } from 'react-dom';
import { popNotification } from '../../data-layer/notifications/actions';
import { selectNotifications } from '../../data-layer/notifications/selectors';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import { useShowBottomStub } from '../../ui/dashboard/SearchAppPanelStub/hooks/useShowBottomStub';
import { Snackbar } from '../../ui/feedback/Snackbar';
import { Toast } from '../../ui/feedback/Toast';
import { Stack } from '../../ui/layout/Stack';
import { withInvariant } from '../../utils/withInvariant';

export const Notifications = withInvariant(
    () => {
        const dispatch = useDispatch();
        const notifications = useSelector((state) => selectNotifications(state));

        // вычисляем страницы где есть боттомбар, чтобы немного поднять плашку
        const hasFixedBottomTabbar = useShowBottomStub();

        return createPortal(
            <Stack
                px={2}
                zIndex={10_000}
                spacing={1}
                position="fixed"
                bottom={{ xs: hasFixedBottomTabbar ? 8 : 2, md: 1 }}
                width={{ xs: '100%', sm: 320 }}
                count={notifications.length}
                renderItem={(index) => {
                    const notification = notifications[index];

                    if (notification.variant === 'toast') {
                        return (
                            <Toast
                                key={notification.id}
                                message={notification.message}
                                subtitle={notification.subtitle}
                                actionText={notification.actionText}
                                onClick={notification.onClick}
                                onRemove={() => dispatch(popNotification(notification))}
                                icon={notification.icon}
                                color={notification.color}
                            />
                        );
                    }

                    return (
                        <Snackbar
                            key={notification.id}
                            message={notification.message}
                            onRemove={() => dispatch(popNotification(notification))}
                        />
                    );
                }}
            />,
            window.document.getElementById('notifications')!,
        );
    },
    () => null,
);
